import { useEffect, useState } from "react";
import {
  Table,
  Card,
  CardBody,
  Badge,
  Spinner,
  Input,
  Button
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getMyFollowUpsApi } from "../../../api/apiUrlConst";
import { startSignalRConnection } from "../../../service/signalrService";
// eslint-disable-next-line
const FILTER_STORAGE_KEY = "myfollowup_filters";
// eslint-disable-next-line
interface Enquiry {
  id: number;
  eid: string;
  name: string;
  email: string;
  phoneNumber: string;
  courseCategory: string;
  courseName: string;
  status: string;
  submittedAt: string;
}

const getStatusColor = (status: string) => {
  switch (status) {
    case "Joined": return "success";
    case "InFollowUp": return "warning";
    case "NotInterested": return "danger";
    case "DND": return "dark";
    default: return "secondary";
  }
};



const MyFollowUps = () => {
  const [followUps, setFollowUps] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [statusFilter, setStatusFilter] = useState(() =>
    sessionStorage.getItem("followup_status") || ""
  );

  const [interestFilter, setinterestFilter] = useState(() =>
    sessionStorage.getItem("followup_interest") || ""
  );

  const [search, setSearch] = useState(() =>
    sessionStorage.getItem("followup_search") || ""
  );
  const [filteredFollowUps, setFilteredFollowUps] = useState<any[]>([]);

const [dueFilter, setDueFilter] = useState(() =>
  sessionStorage.getItem("followup_duefilter") || ""
);

 useEffect(() => {
  sessionStorage.setItem("followup_search", search);
  sessionStorage.setItem("followup_status", statusFilter);
  sessionStorage.setItem("followup_interest", interestFilter);
  sessionStorage.setItem("followup_duefilter", dueFilter);
}, [search, statusFilter, interestFilter, dueFilter]);


  useEffect(() => {
    loadData();

    startSignalRConnection();

  }, []);

  const loadData = async () => {
    try {
      const data = await getMyFollowUpsApi();

      // Group by Enquiry EID and keep latest follow-up
      const latestFollowUps = Object.values(
        data.reduce((acc: any, current: any) => {
          const eid = current.enquiryEID;

          if (!acc[eid]) {
            acc[eid] = current;
            return acc;
          }

          const currentDate = current.nextContactDate
            ? new Date(current.nextContactDate).getTime()
            : 0;

          const existingDate = acc[eid].nextContactDate
            ? new Date(acc[eid].nextContactDate).getTime()
            : 0;

          if (currentDate > existingDate) {
            acc[eid] = current;
          }

          return acc;
        }, {})
      );

      setFollowUps(latestFollowUps);
      setFilteredFollowUps(latestFollowUps);
    } catch {
      toast.error("Failed to load followups");
    } finally {
      setLoading(false);
    }
  };



  // 🔍 Filtering Logic
 useEffect(() => {
  let data = [...followUps];

  if (statusFilter) {
    data = data.filter(
      (f) => f.enquiryStatus === statusFilter
    );
  }

  if (interestFilter) {
    data = data.filter(
      (f) => f.interestLevel === interestFilter
    );
  }

  // Due Status Filter
  if (dueFilter) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    data = data.filter((f) => {
      if (!f.nextContactDate) return false;

      const contactDate = new Date(f.nextContactDate);
      contactDate.setHours(0, 0, 0, 0);

      const isOverdue = contactDate < today;
      const isToday = contactDate.getTime() === today.getTime();
      const isUpcoming = contactDate > today;

      switch (dueFilter) {
        case "Overdue":
          return isOverdue;

        case "Today":
          return isToday;

        case "Upcoming":
          return isUpcoming;

        default:
          return true;
      }
    });
  }

  if (search) {
    const searchLower = search.toLowerCase();

    data = data.filter((f) =>
      f.enquiryName?.toLowerCase().includes(searchLower) ||
      f.enquiryEID?.toLowerCase().includes(searchLower) ||
      f.interestLevel?.toLowerCase().includes(searchLower) ||
      f.enquiryStatus?.toLowerCase().includes(searchLower) ||
      (f.nextContactDate &&
        new Date(f.nextContactDate)
          .toLocaleDateString()
          .toLowerCase()
          .includes(searchLower))
    );
  }

  data.sort((a, b) => {
    const dateA = a.nextContactDate
      ? new Date(a.nextContactDate).getTime()
      : Infinity;

    const dateB = b.nextContactDate
      ? new Date(b.nextContactDate).getTime()
      : Infinity;

    return dateA - dateB;
  });

  setFilteredFollowUps(data);

}, [
  search,
  statusFilter,
  interestFilter,
  dueFilter,
  followUps
]);
const ClearFilter = () => {
  setSearch("");
  setStatusFilter("");
  setinterestFilter("");
  setDueFilter("");

  sessionStorage.removeItem("followup_search");
  sessionStorage.removeItem("followup_status");
  sessionStorage.removeItem("followup_interest");
  sessionStorage.removeItem("followup_duefilter");
};

  if (loading) return <Spinner className="mt-5" />;



  return (
    <div style={{ background: "#f4f6fb", minHeight: "100vh" }}>

      {/* ===== HEADER ===== */}
      <div className="p-4 mb-4"
        style={{
          background: "linear-gradient(90deg ,#374151, #093d92)",
          borderRadius: "16px",
          color: "#fff",
        }}
      >
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center">

          {/* Left Side */}
          <div>
            <h3 className="fw-bold mb-1">My Follow Ups</h3>
            <small>Track today’s and upcoming follow-ups</small>
          </div>

          {/* Right Side Filters */}
          <div className="d-flex flex-column flex-md-row gap-3 mt-3 mt-md-0">

            <Input
              placeholder="🔍 Search Name, Course, EID, Date..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="rounded-pill shadow-sm"
              style={{ width: "260px" }}
            />

            <Input
              type="select"
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              className="rounded-pill shadow-sm"
              style={{ width: "180px" }}
            >
              <option value="">All Status</option>
              <option>New</option>
              <option>Assigned</option>
              <option>InFollowUp</option>
              <option>Joined</option>
              <option>NotInterested</option>
              <option>DND</option>
            </Input>
<Input
  type="select"
  value={dueFilter}
  onChange={(e) => setDueFilter(e.target.value)}
  className="rounded-pill shadow-sm"
  style={{ width: "180px" }}
>
  <option value="">All Due Status</option>
  <option value="Overdue">❗ Overdue</option>
  <option value="Today">🔔 Today</option>
  <option value="Upcoming">⏳ Upcoming</option>
</Input>
            <Input
              type="select"
              value={interestFilter}
              onChange={(e) => setinterestFilter(e.target.value)}
              className="rounded-pill shadow-sm"
              style={{ width: "180px" }}
            >
              <option value="">All Interest</option>
              <option>Hot</option>
              <option>Warm</option>
              <option>Cold</option>
            </Input>

            <Button
              color="primary"
              onClick={ClearFilter}
            >Clear</Button>

          </div>
        </div>
      </div>

      {/* ===== FOLLOWUP TABLE CARD ===== */}
      <Card
        className="border-0 shadow-sm"
        style={{ borderRadius: "16px" }}
      >
        <CardBody>

          <Table
            responsive
            hover
            className="align-middle"
            style={{
              borderCollapse: "separate",
              borderSpacing: "0 8px",
            }}
          >
            <thead>
              <tr style={{ background: "#f4f6fb" }}>
                <th>EID</th>
                <th>Name</th>
                <th>Interest</th>
                <th>Status</th>
                <th>Next Contact</th>
                <th>Message</th>
              </tr>
            </thead>

            <tbody>
              {filteredFollowUps.length === 0 && (
                <tr>
                  <td colSpan={6} className="text-center text-muted py-4">
                    No followups found
                  </td>
                </tr>
              )}

              {filteredFollowUps.map((f) => {

                const today = new Date();
                today.setHours(0, 0, 0, 0);

                const contactDate = f.nextContactDate
                  ? new Date(f.nextContactDate)
                  : null;

                const isToday =
                  contactDate &&
                  contactDate.toDateString() === today.toDateString();

                const isOverdue =
                  contactDate && contactDate < today;

                const isUpcoming =
                  contactDate && contactDate > today;

                return (
                  <tr
                    key={f.id}
                    style={{
                      cursor: "pointer",
                      background: "#fff",
                      boxShadow: "0 2px 10px rgba(0,0,0,0.03)",
                      borderLeft: isOverdue
                        ? "5px solid #ff4d4f"
                        : isToday
                          ? "5px solid #ffc107"
                          : isUpcoming
                            ? "5px solid #52c41a"
                            : "5px solid transparent"
                    }}
                    onClick={() =>
                      navigate(`/coordinator/enquiries/${f.enquiryEID}`)
                    }
                  >
                    {/* EID */}
                    <td className="fw-bold text-primary">
                      {f.enquiryEID}
                    </td>

                    {/* Name */}
                    <td>{f.enquiryName}</td>

                    {/* Interest Level */}
                    <td>
                      <span
                        style={{
                          padding: "5px 12px",
                          borderRadius: "20px",
                          fontSize: "12px",
                          fontWeight: 500,
                          background:
                            f.interestLevel === "Hot"
                              ? "#ffe3e3"
                              : f.interestLevel === "Warm"
                                ? "#fff3bf"
                                : "#e7f5ff",
                          color:
                            f.interestLevel === "Hot"
                              ? "#c92a2a"
                              : f.interestLevel === "Warm"
                                ? "#e67700"
                                : "#1c7ed6",
                        }}
                      >
                        {f.interestLevel}
                      </span>
                    </td>

                    {/* Status */}
                    <td>
                      <Badge
                        color={getStatusColor(f.enquiryStatus)}
                        style={{
                          padding: "6px 12px",
                          borderRadius: "20px",
                        }}
                      >
                        {f.enquiryStatus}
                      </Badge>
                    </td>

                    {/* Next Contact */}
                    <td>
                      <div className="d-flex align-items-center gap-2">

                        <span
                          className={
                            isToday
                              ? "fw-bold text-warning"
                              : isOverdue
                                ? "fw-bold text-danger"
                                : ""
                          }
                        >
                          {f.nextContactDate
                            ? new Date(f.nextContactDate).toLocaleDateString()
                            : "-"}
                        </span>

                        {isOverdue && (
                          <span
                            style={{
                              fontSize: "12px",
                              background: "#ffe3e3",
                              color: "#c92a2a",
                              padding: "2px 8px",
                              borderRadius: "12px",
                              fontWeight: 500
                            }}
                          >
                            ❗ Overdue
                          </span>
                        )}

                        {isToday && (
                          <span
                            style={{
                              fontSize: "12px",
                              background: "#fff3cd",
                              color: "#e67700",
                              padding: "2px 8px",
                              borderRadius: "12px",
                              fontWeight: 500
                            }}
                          >
                            🔔 Today
                          </span>
                        )}

                        {isUpcoming && (
                          <span
                            style={{
                              fontSize: "12px",
                              background: "#e6fcf5",
                              color: "#2b8a3e",
                              padding: "2px 8px",
                              borderRadius: "12px",
                              fontWeight: 500
                            }}
                          >
                            ⏳ Upcoming
                          </span>
                        )}

                      </div>
                    </td>

                    {/* Message */}
                    <td className="text-muted">
                      {f.message}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>

        </CardBody>
      </Card>
    </div>
  );
};

export default MyFollowUps;